import type { ProductCardType } from "@/types/product";

import BookletProductCard from "./variants/BookletProductCard";
import NewlySeenProductCard from "./variants/NewlySeenProductCard";
import RecipeProductCard from "./variants/RecipeProductCard";
import ToolProductCard from "./variants/ToolProductCard";
import YarnProductCard from "./variants/YarnProductCard";

export const isProductCard = (data: any): data is ProductCardType => {
  return data && data.type;
};

const ProductCard = ({ productCard }: { productCard: ProductCardType }) => {
  if (!productCard) return null;
  switch (productCard.type) {
    case "accessory": {
      return <ToolProductCard data={productCard} />;
    }
    case "recipe": {
      return <RecipeProductCard data={productCard} />;
    }
    case "yarn": {
      return <YarnProductCard data={productCard} />;
    }
    case "booklet": {
      return <BookletProductCard data={productCard} />;
    }
    case "imageOnly": {
      return <NewlySeenProductCard data={productCard} />;
    }
    default:
      return null;
  }
};

export default ProductCard;
